import { gql } from '@apollo/client';
import { DELIVERY_TASK_ORDER_FIELDS, DeliveryTaskOrderType } from '../types/DeliveryTaskOrderType';

export interface GetDeliveryPODAbnormalTypeListResponse {
  getDeliveryPODAbnormalTypeListForCurrentUser: DeliveryTaskOrderType[];
}

export const GET_DELIVERY_POD_ABNORMAL_TYPE_LIST = gql`
  query GetDeliveryPODAbnormalTypeListForCurrentUser {
    getDeliveryPODAbnormalTypeListForCurrentUser {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;
